import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UtilService } from 'app/shared/util.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'mh-wait-full',
    templateUrl: './wait_full.component.html',
    styleUrls: ['../../../../../../assets/scss/shared/elements/wait_full.scss'],
    standalone: false
})
export class WaitFullComponent implements OnInit, AfterViewInit, OnDestroy {

  private static rootInstance: WaitFullComponent | null = null;
  private static readonly MIN_VISIBLE_MS = 1700;

  @Input() isRoot = false;

  isReady:boolean=false;
  hidden:boolean=false;
  progess=0;
  numberOfElementWait = 1;
  elementLoad = 0;

  private root: WaitFullComponent | null = null;
  private delegate: WaitFullComponent | null = null;
  private visibleSince = Date.now();
  private subscriptions = new Subscription();

  constructor(
    private utilService:UtilService
  ) {  }

  get state(): WaitFullComponent {
    return this.delegate ?? this;
  }

  get isVisible(): boolean {
    return !this.root && !this.state.hidden;
  }

  ngOnInit() {
    if (this.isRoot) {
      WaitFullComponent.rootInstance = this;
      return;
    }
    const root = WaitFullComponent.rootInstance;
    if (root?.isVisible && !root.delegate) {
      this.root = root;
      root.delegate = this;
      this.visibleSince = root.visibleSince;
    }
  }

  ngAfterViewInit() {
    if (this.isRoot) return;
    this.subscriptions.add(this.utilService.isLoadCustomerReady().subscribe(() => this.readyToLoad()));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    if (this.root?.delegate === this) {
      this.root.delegate = null;
      this.root.hidden = true;
    }
    if (WaitFullComponent.rootInstance === this) WaitFullComponent.rootInstance = null;
  }

  release() {
    if (!this.delegate) this.fadeOut();
  }

  readyToLoad(){
    this.elementLoad = this.elementLoad<=this.numberOfElementWait ? (this.elementLoad+1) : this.numberOfElementWait;
    this.progess = Math.round(100/this.numberOfElementWait*this.elementLoad);
    if(this.elementLoad>=this.numberOfElementWait) this.setReady();
  }

  setReady(){
    const elapsed = Date.now() - this.visibleSince;
    setTimeout(() => this.fadeOut(), Math.max(0, WaitFullComponent.MIN_VISIBLE_MS - elapsed));
  }

  private fadeOut() {
    this.isReady = true;
    setTimeout(() => {
      this.hidden = true;
    },100);
  }

}
